import { render, staticRenderFns } from "./AddCategories.vue?vue&type=template&id=7ea6c2c1&scoped=true"
import script from "./AddCategories.vue?vue&type=script&lang=js"
export * from "./AddCategories.vue?vue&type=script&lang=js"
import style0 from "./AddCategories.vue?vue&type=style&index=0&id=7ea6c2c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea6c2c1",
  null
  
)

export default component.exports